export default __webpack_public_path__ + "static/media/16.733a8e77.png";